import { useReactiveVar } from "@apollo/client";
import { localEditorMediaLibraryByAudienceCaseIndex } from "../../State";

export const useMediaLibraryByAudienceCaseIndex = () => useReactiveVar(localEditorMediaLibraryByAudienceCaseIndex);
